<template>
  <div>
    <div id="header" class="header">
      <div class="header-nav"><!-- 공백 --></div>
      <div class="header-gnb">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.png" alt="wavve"/>
          </a>
        </h1>
        <ul class="gnb-left">
          <li><a href="/customer/company.html" id="g-menu">회사소개</a></li>
          <li><a href="/customer/business.html">사업제휴</a></li>
          <li><a href="/customer/recruit.html">인재채용</a></li>
          <li><a href="/customer/financial_statements.html" class="on">투자정보</a></li>
        </ul>
      </div>
    </div>

    <!-- 콘텐츠 영역 -->
    <div id="container" class="container">
      <div class="service">
        <div class="top-contents company-top-contents" id="g-contents">
          <div class="wrap">
            <h1 class="cp-h1">재미의 파도를 타다!<br/>콘텐츠웨이브</h1>
          </div>
        </div>
        <div id="sticky-menu" class="sticky-navigation">
          <ul>
            <li>
              <a href="#i-sec01" v-smooth-scroll="{offset:-64}" class="scroll on">전자공고</a>
            </li>
          </ul>
        </div>
        <div class="contents-wrap">
          <div id="i-sec01">
            <div class="ability-sec02">
              <div class="if-wrap">
                <h2 class="title tAc">전자공고</h2>
                <template v-if="!dataDetail">
                  <table class="ab-sec02-table">
                    <colgroup>
                      <col width="*"/>
                      <col width="140px"/>
<!--                      <col width="140px"/>-->
                    </colgroup>
                    <tr>
                      <th colspan="row">제목</th>
                      <th colspan="row">등록일</th>
<!--                      <th colspan="row">다운로드</th>-->
                    </tr>
                    <!-- 채용 목록 리스트 -->
                    <tr v-for="(data, index) in dataList" :key="index" :class="data.istop ==='y' ? 'noti-top' : ''">
                      <td class="tAl">
                        <a href="#" @click.prevent="showDetail(data)" v-html="data.boardtitle + (data.isNew === 'y' ? '<i>NEW</i>' : '')">
                        </a>
                      </td>
                      <td>{{ data.regdate }}</td>
<!--                      <td>-->
<!--                        <button @click.prevent="fileDownload(data)" class="button-download">다운로드</button>-->
<!--                      </td>-->
                    </tr>
                  </table>
                  <paging-component :current-page="page"
                                    :page-count="pageCount"
                                    :limit="limit"
                                    :paging-count="10"
                                    :isLoading="false"/>
                </template>
                <template v-else-if="dataDetail">
                  <table class="ab-sec02-table hover-none">
                    <colgroup>
                      <col width="*">
                      <col width="140px">
                    </colgroup>
                    <tbody><tr>
                      <th>제목</th>
                      <th>등록일</th>
                    </tr>
                    <tr>
                      <td class="tAl">
                        <p class="title" v-html="dataDetail.boardtitle + (dataDetail.isNew === 'y' ? '<i>NEW</i>' : '')"></p>
                      </td>
                      <td>{{ dataDetail.regdate }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="table-wrapper" v-html="dataDetail.content"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <a @click.prevent="showList()" href="#" class="prev-list">
                    <img src="../../assets/images/service/btn-list.png" alt="list">
                    목록
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PagingComponent from '@/components/common/PagingComponent'
  import queryString from '@/common/utils/querystring'
  import FinancialStatementList from '@/pages/customer/financial_statements_list'

  export default {
    components: {
      PagingComponent
    },
    data () {
      return {
        page: +queryString.getQueryParamValue(this.$route, 'page', '1'),
        category: queryString.getQueryParamValue(this.$route, 'category', 'all'),
        sticky: false,
        dataList: undefined, // 채용 목록 데이터
        dataDetail: undefined, // 채용 상세 데이터
        limit: 10,
        pageCount: 0,
        orderby: 'new'
      }
    },
    methods: {
      showDetail (data) {
        this.dataDetail = data
      },
      callApi () {
        this.dataDetail = null
        this.dataList = FinancialStatementList.list
        this.pageCount = +FinancialStatementList.pagecount
      },
      showList () {
        this.dataDetail = null
      }
      // fileDownload (data) {
      //   let link = document.createElement('a')
      //   link.download = data.filename
      //   link.href = data.download
      //   document.body.appendChild(link)
      //   link.click()
      //   document.body.removeChild(link)
      // },
    },
    mounted () {
      let stickyMenu = document.getElementById('sticky-menu')
      let stickyMenuOffset = stickyMenu.offsetTop
      window.onscroll = function () {
        if (window.pageYOffset >= stickyMenuOffset - 109) {
          stickyMenu.classList.add('sticky')
        } else {
          stickyMenu.classList.remove('sticky')
        }
      }
      this.callApi()
    }
  }
</script>
<style lang="css" src="@/assets/css/service.css"></style>
